import React from "react";
import { RotatingLines } from "react-loader-spinner";
import { tokens } from "../../theme/tokens";

type Props = {
  size?: number | string;
  className?: string;
};

export default function Spinner({ size = 80, className = "" }: Props) {
  return (
    <div className={`inline-flex ${className}`}>
      {React.createElement(RotatingLines as any, {
        strokeColor: tokens.primary,
        strokeWidth: "4",
        animationDuration: "0.8",
        width: String(size),
        visible: true,
      })}
    </div>
  );
}
